import { Search, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const AVAILABILITY = ["In Stock", "Low Stock", "Out of Stock", "Contact Us"];

export const CategoryTabs = ({ categories, total, active, onChange }) => {
  const tabs = [{ name: "All Products", count: total }, ...(categories || [])];
  return (
    <div className="no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 sm:mx-0 sm:px-0" role="tablist" data-testid="category-tabs">
      {tabs.map((c) => {
        const on = active === c.name;
        return (
          <button key={c.name} role="tab" aria-selected={on} onClick={() => onChange(c.name)} data-testid={`category-tab-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`flex h-12 shrink-0 items-center gap-2 rounded-full border px-5 text-sm font-semibold transition-colors duration-300 ${on ? "border-[#1B4332] bg-[#1B4332] text-[#FDFBF7]" : "border-[#E5E0D8] bg-white text-[#1F2421] hover:border-[#1B4332]/50"}`}>
            {c.name}
            <span className={`rounded-full px-2 py-0.5 text-xs ${on ? "bg-white/15" : "bg-[#F4EEE2] text-[#8B5A2B]"}`}>{c.count ?? 0}</span>
          </button>
        );
      })}
    </div>
  );
};

export const SearchBar = ({ value, onChange, availability, onAvailability }) => (
  <div className="flex flex-col gap-3 sm:flex-row">
    <label className="relative flex-1">
      <span className="sr-only">Search products</span>
      <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-[#8B5A2B]" />
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder="Search by name, material, size, SKU…" data-testid="catalogue-search-input"
             className="h-12 w-full rounded-full border border-[#E5E0D8] bg-white pl-12 pr-11 text-base outline-none transition-shadow focus:border-[#C59B27] focus:ring-4 focus:ring-[#C59B27]/15" />
      {value && (
        <button onClick={() => onChange("")} className="absolute right-3 top-1/2 grid h-8 w-8 -translate-y-1/2 place-items-center rounded-full text-[#5B625D] hover:bg-[#F4EEE2]" aria-label="Clear search" data-testid="catalogue-search-clear">
          <X className="h-4 w-4" />
        </button>
      )}
    </label>
    <Select value={availability || "all"} onValueChange={(v) => onAvailability(v === "all" ? "" : v)}>
      <SelectTrigger className="h-12 w-full rounded-full border-[#E5E0D8] bg-white px-5 sm:w-52" data-testid="availability-filter">
        <SelectValue placeholder="Availability" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="availability-option-all">Any availability</SelectItem>
        {AVAILABILITY.map((a) => <SelectItem key={a} value={a} data-testid={`availability-option-${a.toLowerCase().replace(/\s+/g, "-")}`}>{a}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);
